// Shared stable empty object for hook defaults to avoid recreating {} each render.
export const EMPTY_CONTEXT = Object.freeze({}) as Readonly<
  Record<string, unknown>
>;
